import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Card, CardBody, Button, Textarea, Badge, Select, SelectItem, Chip, addToast, Tabs, Tab } from "@heroui/react";
import { Package, DollarSign, Boxes, Calendar, Upload, ImagePlus, FileText, Layers, CheckCircle, RulerIcon, XCircle, TagIcon, Building, Users, PackageOpen } from "lucide-react";
import api from "../../api/api";
import { useToast } from "../../context/toast";
import choices from "../../utils/choice-keys";
import { useLocation } from "react-router-dom";

// 🎯 Faux images pour la carrousel

export default function ProductCreateForm() {
  const [product, setProduct] = useState({
    name: "",
    description: "",
    price: "",
    stock_quantity: "",
    image: "",
    product_type : "",
    limit_stock : 10,
  });

  const [pricing, setPricing] = useState({
    unit : 'kg',
    price : null,
    min : null

  })

  const [categories, setCategories] = useState([])
  const [preview, setPreview] = useState(null);
  const [isCreating, setIsCreating] = useState(false);

  const showToast = useToast()


  const [selectedCategories, setSelectedCategories] = useState([]);

  // 📌 Gérer la sélection des catégories
  const handleSelectionChange = (catId) => {

    setSelectedCategories((prevSelected) =>
      prevSelected.includes(catId)
        ? prevSelected.filter((id) => id !== catId) // Retirer si déjà sélectionné
        : [...prevSelected, catId] // Ajouter si non sélectionné
    );
  };

  const location = useLocation()
  
  useEffect(() => {

    const dataToCache = { product, pricing };
    localStorage.setItem(choices.product.product_create_form_cache, JSON.stringify(dataToCache));

  }, [product, pricing]);



  useEffect(() => {

    const cache = localStorage.getItem(choices.product.product_create_form_cache);
    
    if (cache) {

      const { product, pricing } = JSON.parse(cache);
      setProduct((prev)=>({...prev, ...product}));
      setPricing((prev)=>({...prev, ...pricing}));

    }

  }, []);
  
  


  // Gestion du changement des inputs
  const handleChange = (e) => {
    setProduct({ ...product, [e.target.name]: e.target.value });
    // localStorage.setItem(choices.product.product_create_form_cache, JSON.stringify({ ...product, [e.target.name]: e.target.value }))
  };

  const handleChangePrice = (e) => {
    
    setPricing({ ...pricing, [e.target.name]: e.target.value });
    // localStorage.setItem(choices.product.product_create_form_cache, JSON.stringify({...product, pricing : { ...pricing, [e.target.name]: e.target.value }}))

  };


  const handleCreateProduct = async ()=>{

    console.log(product)

    if(product.product_type === 'particular' && (!product.name || !product.price || !product.description || !product.image || !product.stock_quantity)) return showToast("Veuillez entrez toutes les informations", "warning")
    if(product.product_type === 'enterprise' && ((!product.name || !product.description || !product.image || !product.stock_quantity) || (!pricing.price || !pricing.min || !pricing.unit))) return showToast("Veuillez entrez toutes les informations", "warning")

    setIsCreating(true)

    try{

        const formData = new FormData();

        for (const key in product) {
          formData.append(key, product[key]);
        }

        formData.append('category', JSON.stringify(selectedCategories))


        formData.append('pricing', JSON.stringify(pricing))


        await api.product.create(formData)


        setProduct({
          name: "",
          description: "",
          price: "",
          stock_quantity: "",
          image: "",
          product_type : "",
        })
        
        setSelectedCategories([])


        setPricing({
          unit : 'kg',
          price : null,
          min : null
        })

        showToast("Produit crée avec success", "success")
        setIsCreating(false)

        localStorage.removeItem(choices.product.product_create_form_cache)

    }catch(e){

      showToast("Une erreur s'est produite lors de la creation du produit", "error")
      setIsCreating(false)

    }

  }

  const handleFileChange = (e) => {
    
    const file = e.target.files[0];

    if (file) {
      
      setProduct({ ...product, [e.target.name]: e.target.files[0] });

      // Création d'un aperçu de l'image
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(file);

    }
  };


  useEffect(()=>{

    const fetch = async ()=>{

        try{

            const data = await api.category.read()

            setCategories(data)


        }catch(e){

            console.log(e)

        }
    }

    fetch()

  }, [])

  return (
    <div className="max-w-3xl p-6 mx-auto space-y-6">
      {/* 🏷️ Titre */}
      <h2 className="flex items-center gap-2 text-2xl font-semibold">
        <Package size={24} className="text-primary" /> Créer un Nouveau Produit
      </h2>

      <Tabs
        // onSelectionChange={(key)=>{setProduct((prev)=>({...prev, product_type : key})) ; localStorage.setItem(choices.product.product_create_form_cache, JSON.stringify({...product, product_type : key}))}}
        onSelectionChange={(key)=>{setProduct((prev)=>({...prev, product_type : key}))}}
        color="primary"
        selectedKey={product.product_type}
      >
          <Tab 
            key="particular" 
            title={            
              <div className="flex items-center space-x-2">
                <Users size={15}/>
                <sapn>Particuler</sapn>
              </div>
          }/>

          <Tab 
            key="enterprise" 
            title={            
              <div className="flex items-center space-x-2">
                <Building size={15}/>
                <sapn>Entreprise</sapn>
              </div>
            }
          />
          
      </Tabs>

      {/* 🎠 Carrousel d'Images */}
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }} className="flex justify-center items-center">
          <img src={preview} alt="Produit" className="rounded-lg shadow-md w-60 h-60" /> 
      </motion.div>

      {/* 📝 Formulaire */}
      <motion.form initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }} className="space-y-4">
        {/* Nom du produit */}
        <div className="flex flex-col">
          <label className="flex items-center gap-2 font-medium"><FileText size={18} /> Nom du produit</label>
          <input 
            type="text" name="name" placeholder="Nom du produit..." required 
            value={product.name} onChange={handleChange} 
            className="p-2 border rounded-lg shadow-sm focus:outline-primary dark:border-zinc-700 dark:bg-zinc-700"
          />
        </div>

        {/* Description */}
        <div className="flex flex-col">
          <label className="flex items-center gap-2 font-medium"><Layers size={18} /> Description</label>
          <textarea 
            name="description" placeholder="Décrivez le produit..." required
            value={product.description} onChange={handleChange}
            className="p-2 border rounded-lg shadow-sm focus:outline-primary dark:border-zinc-700 dark:bg-zinc-700"
          />
        </div>

        {/* Prix et Catégorie */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {/* Prix */}
          {product.product_type === 'particular' && <div className="flex flex-col">
            <label className="flex items-center gap-2 font-medium"><DollarSign size={18} /> Prix (€) / Article</label>
            <input 
              type="number" name="price" placeholder="Prix du produit..." required
              value={product.price} onChange={handleChange}
              className="p-2 border rounded-lg shadow-sm focus:outline-primary dark:border-zinc-700 dark:bg-zinc-700"
            />
          </div>}


          {product.product_type === 'enterprise' && <div className="flex flex-col">
            <label className="flex items-center gap-2 font-medium"><PackageOpen size={18} /> Prix / kg</label>
            <input 
              type="number" name="price" placeholder="Prix du produit..." required
              value={pricing.price} onChange={handleChangePrice}
              className="p-2 border rounded-lg shadow-sm focus:outline-primary dark:border-zinc-700 dark:bg-zinc-700"
            />
          </div>}

          {product.product_type === 'enterprise' && <div className="flex flex-col">
            <label className="flex items-center gap-2 font-medium"><DollarSign size={18} /> Qty min / achat</label>
            <input 
              type="number" name="min" placeholder="Quantité minimum par achat" 
              required
              value={pricing.min} onChange={handleChangePrice}
              className="p-2 border rounded-lg shadow-sm focus:outline-primary dark:border-zinc-700 dark:bg-zinc-700"
            />
          </div>}

          {/* Catégorie */}
          <div className="flex flex-col">
            <label className="flex items-center gap-2 font-medium"><Boxes size={18} /> Catégorie</label>
            <div className="py-5 space-x-4 space-y-4">
              {categories.map((cat) => (
                <Button
                  key={cat.id}
                  startContent={<TagIcon className="w-4 h-4"/>}
                  size="sm"
                  onPress={() => handleSelectionChange(cat.id)}
                  className={`transition-colors  ${
                    selectedCategories.includes(cat.id) ? "bg-green-600 text-white" : "bg-gray-200 dark:bg-zinc-800"
                  }`}
                >
                  {cat.name}
                </Button>
              ))}
          </div>
          </div>
        </div>


        {/* Stock */}
        <div className="flex flex-col">
          <label className="flex items-center gap-2 font-medium"><CheckCircle size={18} /> Quantité en Stock</label>
          <input 
            type="number" name="stock_quantity" placeholder="Stock disponible..." required
            value={product.stock_quantity} onChange={handleChange}
            className="p-2 border rounded-lg shadow-sm focus:outline-primary dark:border-zinc-700 dark:bg-zinc-700"
          />
        </div>

        <div className="flex flex-col">
          <label className="flex items-center gap-2 font-medium"><CheckCircle size={18} />Stock limit</label>
          <input 
            type="number" name="limit_stock" placeholder="Stock limit..." required
            value={product.limit_stock} onChange={handleChange}
            className="p-2 border rounded-lg shadow-sm focus:outline-primary dark:border-zinc-700 dark:bg-zinc-700"
          />
        </div>

        {/* Upload Image */}
        <div className="flex flex-col">
          <label className="flex items-center gap-2 font-medium"><Upload size={18} /> Image du Produit</label>
          <input type="file" accept="image/*" name='image' onChange={handleFileChange} className="p-2 border rounded-lg shadow-sm focus:outline-primary dark:border-zinc-700 dark:bg-zinc-700" />
        </div>


        {/* Bouton de soumission */}
        <Button 
          color="primary" 
          fullWidth 
          onPress={handleCreateProduct} 
          isLoading={isCreating}
        >
          Ajouter le Produit
        </Button>

      </motion.form>
    </div>
  );
}
